<template>
  <generic-container
    :title="$t('providers')"
    icon="arrow alternate circle up outline"
    :show_plus="true"
    :show_refresh="true"
    @add="add"
    @refresh="init"
  >
    <div class="ui two link cards">
      <div
        class="ui card"
        v-for="(provider, index) in providers"
        :key="index"
        @click="edit(provider)"
      >
        <div class="content">
          <a class="ui header"
            >{{ provider.name }}
            <div class="sub header">{{ provider.library }}</div></a
          >

          <!-- <div class="description">
            {{ provider.setup.setup }}
          </div> -->
        </div>
      </div>
    </div>
    <provider-modal ref="provider_modal" @success="init" @deleted="init" />
  </generic-container>
</template>

<script>
import { local_api } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ProviderModal from "./provider_modal/Index";

export default {
  name: "Providers",
  components: { GenericContainer, ProviderModal },
  data() {
    return {
      providers: [],
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.provider_modal.show_modal();
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/outbox/provider/do-get-list").then(
        (providers) => {
          vm.providers = providers;
        },
      );
    },
    edit(provider) {
      let vm = this;
      vm.$refs.provider_modal.show_modal(provider);
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
